/* eslint-disable indent */
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

import ReactHTMLTableToExcel from "react-html-table-to-excel";

import { loginTypeConstant } from "../../../constant/loginType/loginTypeConstant";
import TopInput from "./TopInput";
import {
  attendanceActions,
  locationActions
} from "../../../redux/actions";
import AttendanceUserList from "./AttendanceUserList";
import { AttendanceTypes } from "../../../redux/type/type";
import { helperFunction } from "../../../constant/helper";
// import moment from "moment";
import {
  // createdAsFunction,
  renderDate,
  renderSheetCreatedAs,
  // TimeStampIntoHours,
  totalPAH
} from "../../../constant/helper/helper";
import Starter from "../../../component/Starter";
import isEmpty from "../../../validation/isEmpty";
import { getAllZones } from "../../../redux/actions/hrActions";

const initialState = {
  Filter: "",
  toDate: "",
  fromDate: "",
  dataFormat: "ABP",
  locationId: "",
  exportFullData: "NO"
};

const AttendanceSheet = () => {
  const componentRef = useRef();

  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const [values, setValues] = useState(initialState);
  const [searchTerm, setSearchTerm] = useState("");
  const [zoneData, setZoneData] = useState([]);
  const [zone, setZone] = useState("");
  const [allLocations, setAllLocations] = useState([]);
  const [dateDifference, setDateDifference] = useState(0);
  const [dateArrayState, setDateArrayState] = useState([]);
  const [sheetAttendanceData, setSheetAttendanceData] = useState([]);

  const { locations } = useSelector((state) => state.location);
  const { currentUser } = useSelector((state) => state.auth);
  const {
    toDate,
    fromDate,
    locationId,
    attendanceError,
    attendanceLoading,
    attendanceSheetData
  } = useSelector((state) => state.attendance);
  const { allZones } = useSelector((state) => state.hr);

  useEffect(() => {
    if (!isEmpty(allZones)) {
      setZoneData(allZones);
    } else {
      setZoneData([]);
    }
  }, [allZones]);

  useEffect(() => {
    dispatch(getAllZones(loginType));
  }, []);

  useEffect(() => {
    if (!isEmpty(attendanceSheetData)) {
      setSheetAttendanceData(
        attendanceSheetData.map((sheet) => {
          const dailyPoints = [];

          const obj = _.mapKeys(sheet.attendances, "Date");
          dateArrayState.forEach((dateValue2) => {
            let createdAs;
            let duration;
            let shiftCode;
            let inTime;
            let outTime;

            if (isEmpty(obj[dateValue2])) {
              createdAs = "-";
              duration = "00:00:00";
              shiftCode = "-";
              inTime = "-";
              outTime = "-";
            } else {
              createdAs = renderSheetCreatedAs(obj[dateValue2]);
              duration = obj[dateValue2].duration;
              shiftCode = obj[dateValue2].shiftCode;
              inTime = obj[dateValue2].inTime;
              outTime = obj[dateValue2].outTime;
            }

            return dailyPoints.push({
              Date: dateValue2,
              shiftCode,
              createdAs,
              inTime: inTime,
              outTime: outTime,
              duration: duration
            });
          });

          const {
            TotalPresent,
            TotalAbsent,
            TotalWeekOf,
            TotalPl,
            TotalNbl,
            TotalPtl,
            TotalMtl,
            TotalBl,
            TotalCo,
            TotalOh,
            TotalPh,
            TotalOd,
            TotalEo,
            TotalLc,
            TotalHd,
            TotalOT,
            TotalAml,
            TotalWop
          } = totalPAH(dailyPoints);
          return {
            Location: sheet.locationName,
            workerId: sheet.workerId,
            dailyPointsArray: dailyPoints,
            employeeId: sheet._id,
            TotalPl,
            TotalNbl,
            TotalPtl,
            TotalMtl,
            TotalBl,
            TotalCo,
            TotalOh,
            TotalPh,
            TotalOd,
            TotalEo,
            TotalLc,
            TotalHd,
            TotalOT,
            TotalAml,
            TotalWop,
            TotalPresent: TotalPresent,
            TotalAbsent: TotalAbsent,
            TotalWeekOf: TotalWeekOf,
            totalDays: !isEmpty(dateArrayState)
              ? dateArrayState.length
              : 0,
            workerFullName:
              sheet.workerFirstName + " " + sheet.workerSurname,
            total_shift_points: sheet.total_shift_points,
            workerDepartment: sheet.workerDepartment,
            workerDesignation: sheet.workerDesignation,
            zoneId: sheet.zoneId
          };
        })
      );
    }
  }, [attendanceSheetData]);

  useEffect(() => {
    if (attendanceError) {
      helperFunction.toastHelper("error", attendanceError);
    }
  }, [attendanceError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    setValues({
      ...values,
      fromDate,
      toDate,
      locationId
    });
  }, [fromDate, toDate, locationId]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    // dispatch(locationActions.getAllLocation(loginType));
    return () => {
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
      dispatch(attendanceActions.unmountAttendanceData());
    };
  }, []);

  // fetch attendance
  const fetchAttendanceSheet = (e) => {
    e.preventDefault();
    const { fromDate, toDate, locationId, dataFormat } = values;
    if (fromDate === "" || toDate === "") {
      const errorData = {
        data: {
          message: "From Date,To Date or Location is not selected"
        },
        status: 400
      };
      return dispatch({
        type: AttendanceTypes.ATTENDANCE_GET_ERRORS,
        payload: errorData
      });
    } else {
      const diffTime = Math.abs(
        new Date(toDate) - new Date(fromDate)
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setDateDifference(diffDays);
      const dateArray = renderDate(values);
      const attendanceType = "location";
      setDateArrayState(dateArray);
      dispatch(attendanceActions.setAttendanceLoading(true));
      dispatch(attendanceActions.clearAttendanceErrors());
      dispatch(attendanceActions.clearAttendanceResult());
      dispatch(attendanceActions.unmountAttendanceData());

      dispatch(
        attendanceActions.getAttendanceSheet(
          fromDate,
          toDate,
          locationId,
          loginType,
          attendanceType,
          dataFormat
        )
      );
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const [currentPage, setCurrentPage] = useState(1);

  return (
    <Starter
      topBarTitle="Attendance"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Attendance Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Attendance</a>
          </li>
          <li className="breadcrumb-item active">Attendance Sheet</li>
        </Fragment>
      }
    >
      <TopInput
        values={values}
        currentUser={currentUser}
        loading={attendanceLoading}
        onChange={handleInputChange}
        onSubmit={fetchAttendanceSheet}
        handleSearchChange={handleSearchChange}
        allLocations={
          typeof allLocations !== "undefined" &&
          allLocations.length > 0
            ? allLocations
            : []
        }
        zoneData={zoneData}
        zone={zone}
        setZone={(e) => setZone(e.target.value)}
      />
      <AttendanceUserList
        values={values}
        loginType={loginType}
        excelRef={componentRef}
        searchTerm={searchTerm}
        currentPage={currentPage}
        loading={attendanceLoading}
        setSearchTerm={setSearchTerm}
        setCurrentPage={setCurrentPage}
        dateDifference={dateDifference}
        dateArrayState={dateArrayState}
        loginTypeConstant={loginTypeConstant}
        setDateArrayState={setDateArrayState}
        attendanceSheetData={sheetAttendanceData}
        zone={zone}
      />
      <div className="row mt-3">
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
        <div className="col-2">
          <ReactHTMLTableToExcel
            sheet="Sheet"
            buttonText="Export excel"
            table="products-datatable"
            className="btn btn-dark btn-block"
            filename={`${fromDate}_${toDate}`}
          />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
      </div>
    </Starter>
  );
};

export default AttendanceSheet;
